import colorVars from "@/assets/styles/colorVars"
import SparklesSrc from "@/assets/svg/ui/sparkles.inline.svg"
import React, { FC } from "react"
import styled from "styled-components"

export interface PillTagProps {
  className?: string
  color?: "blue" | "orange" | "pink" | "sparkles" | "teal" | "violet" | "yellow"
  title?: string
}

export const PillTitle = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: #fff;
  text-transform: uppercase;

  background-clip: text;
  /* stylelint-disable-next-line */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

export const PillWrapper = styled.div<PillTagProps>`
  display: inline-flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  width: auto;
  padding: 6px 14px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 16px;
  backdrop-filter: blur(20px);

  ${(props) => {
    if (props.color === "pink") {
      return `
        border: 1px solid ${colorVars.pink.stroke50};
        ${PillTitle} {
          background-image: ${colorVars.pink.textGradient};
        }
      `
    } else if (props.color === "blue") {
      return `
      border: 1px solid ${colorVars.blue.stroke50};
        ${PillTitle} {
          background-image: ${colorVars.blue.textGradient};
        }
      `
    } else if (props.color === "violet") {
      return `
        border: 1px solid ${colorVars.violet.stroke50};
        ${PillTitle} {
          background-image: ${colorVars.violet.textGradient};
        }
      `
    } else if (props.color === "teal") {
      return `
      border: 1px solid ${colorVars.teal.stroke50};
        ${PillTitle} {
          background-image: ${colorVars.teal.textGradient};
        }
      `
    } else if (props.color === "yellow") {
      return `
      border: 1px solid ${colorVars.yellow.stroke50};
        ${PillTitle} {
          background-image: ${colorVars.yellow.textGradient};
        }
      `
    } else if (props.color === "orange") {
      return `
      border: 1px solid ${colorVars.orange.stroke50};
        ${PillTitle} {
          background-image: ${colorVars.orange.textGradient};
        }
      `
    } else if (props.color === "sparkles") {
      return `
        && {
          position: relative;
          padding: 6px 16px;
          justify-content: center;
          align-items: center;
          gap: 8px;
          background: rgba(255, 255, 255, 0.10); 
          /* 
            #1b1e2e is the background color picked color with the dark blue bg,
            #1e434f is the greensish color picked from the left hand side of the stroke
            #49273f is the pinkish color picked from the right hand side of the stroke
            we need solid colors to be able to apply the gradient stroke effect
          */
          background: linear-gradient(to right,#1b1e2e,#1b1e2e) padding-box,linear-gradient(to right,#1e434f,#49273f) border-box;
          border: 1px solid transparent;

          @media (prefers-reduced-motion: no-preference) {
            animation: glow-pulse 3.5s ease infinite;
          }

          @keyframes glow-pulse {
            5% {
              box-shadow: none;
            }
            30% {
              box-shadow: inset 0 0 6px 0 rgb(174 178 255 / 13%), inset 0 0 14px 0 rgb(174 178 255 / 5%);
            }
            60% {
              box-shadow: none;
            }
          }

          ${PillTitle} {
            background-clip: initial;
            -webkit-background-clip: initial;
            -webkit-text-fill-color: initial;
          }

          &::after {
            content: "";
            position: absolute;
            display: block;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 16px;
            background: linear-gradient(33.5deg, rgb(255 255 255 / 0%) 40%, rgb(255 255 255 / 50%) 50%, rgb(255 255 255 / 0%) 60%);
            background-size: 240% 100%;
            background-repeat: no-repeat;
            z-index: -1;
            opacity: 0.5;

            @media (prefers-reduced-motion: reduce) {
              display: none;
            }

            @media (prefers-reduced-motion: no-preference) {
              animation: background-sheen 3.5s ease infinite;
            }

            @keyframes background-sheen {
              0% {
                background-position: 120% 0;
              }
              100% {
                background-position: -120% 0;
              } 
            }
          }
        }
      `
    }
  }}
`

const Sparkles = styled(SparklesSrc)`
  filter: drop-shadow(0 0 10px transparent);

  @media (prefers-reduced-motion: no-preference) {
    animation: sparkle 3.5s ease infinite;
  }

  @keyframes sparkle {
    0% {
      filter: drop-shadow(0 0 10px transparent);
      transform: scale(1);
    }
    50% {
      filter: drop-shadow(0 0 8px ${colorVars.blue.p6});
      transform: scale(1.1);
    }
    100% {
      filter: drop-shadow(0 0 10px transparent);
      transform: scale(1);
    }
  }
`

export const PillTag: FC<PillTagProps> = (props) => {
  if (!props.title || props.title === "") {
    return null
  }

  return (
    <PillWrapper
      className={props.className || ""}
      color={props.color || "pink"}>
      {props.color === "sparkles" && <Sparkles height="18px" width="18px" />}
      <PillTitle>{props.title}</PillTitle>
    </PillWrapper>
  )
}
